import { ContainerModule } from 'inversify'
import { SiteStore } from 'store/site'
import Types from '../../config/inversify.types'
import { SiteServiceImpl } from './site.service.impl'

export const SiteModule = new ContainerModule((bind) => {
    bind(Types.SiteService).to(SiteServiceImpl).inSingletonScope()
    bind(Types.SiteStore).to(SiteStore).inSingletonScope()
})
